import { Card, CardBody, Col, ListGroup, ListGroupItem } from "reactstrap";
import { Image } from "../../../AbstractElements";
import { BorderPrimaryTitle } from "../../../Constants/Constants";
import { BorderPrimaryData, BorderPrimarySubTitle } from "../../../Data/BonusUi/CreativeCard";
import { dynamicImage } from "../../../Utils";
import CommonCardHeader from "../../CommonComponents/CommonCardHeader/CommonCardHeader";

const BorderPrimary = () => {
  return (
    <Col md="6" xl="4">
      <Card className="height-equal">
        <CommonCardHeader title={BorderPrimaryTitle} span={BorderPrimarySubTitle} headClass="border-l-primary border-3 pb-0" />
        <CardBody>
          <ListGroup>
            {BorderPrimaryData.map((item) => (
              <ListGroupItem action className={`${item.id === 1 ? "active" : ""}`} key={item.id}>
                <Image className="rounded-circle" src={dynamicImage(`user/${item.image}`)} alt="user" />
                {item.name}
              </ListGroupItem>
            ))}
          </ListGroup>
        </CardBody>
      </Card>
    </Col>
  );
};
export default BorderPrimary;
